import React from 'react';

const Footer = () => {
    return (
      <div className="footer">
        <p className="text-center mx-auto">© 2020 - AgriCart by <a href="https://github.com/gokul112" target="_blank" rel="noopener noreferrer" >Gokulraj</a></p>
    </div>

    )
}
export default Footer;